var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"s-btn"},[_c('button',{class:_vm.getClasses(),style:(_vm.styleMap),attrs:{"type":_vm.btnType,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onClick}},[(_vm.icon)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }